import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { useLandingSettings } from '../hooks/useLandingSettings';

const Footer: React.FC = () => {
  const { settings } = useLandingSettings();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Sección principal del footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo y descripción */}
          <div>
            <img
              src="/img/logomultigym_h_b.png"
              alt="MultiGym Logo"
              className="h-10 mb-4"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = 'public/img';
              }}
            />
            <p className="mb-4">
              La solución más completa para la gestión de tu gimnasio. Desde el control de acceso hasta la administración de pagos.
            </p>
            <div className="flex space-x-4">
              {settings.showFacebook && (
                <a href={settings.facebookUrl} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook">
                  <FaFacebook />
                </a>
              )}
              {settings.showTwitter && (
                <a href={settings.twitterUrl} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors flex items-center justify-center" aria-label="X (Twitter)">
                  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current" aria-hidden="true">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
              )}
              {settings.showInstagram && (
                <a href={settings.instagramUrl} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram">
                  <FaInstagram />
                </a>
              )}
              {settings.showLinkedin && (
                <a href={settings.linkedinUrl} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn">
                  <FaLinkedin />
                </a>
              )}
            </div>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Enlaces rápidos</h3>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="hover:text-white transition-colors">Inicio</a>
              </li>
              <li>
                <a href="#features" className="hover:text-white transition-colors">Características</a>
              </li>
              <li>
                <a href="https://app.multigym.com.ar/" className="hover:text-white transition-colors">Registro</a>
              </li>

              <li>
                <a href="#download" className="hover:text-white transition-colors">Descarga la App</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-white transition-colors">Contacto</a>
              </li>
            </ul>
          </div>

          {/* Contáctanos */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contáctanos</h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:info@multigym.com.ar" className="hover:text-white transition-colors">
                  info@multigym.com.ar
                </a>
              </li>
              <li>
                <a href="tel:+123456789" className="hover:text-white transition-colors">
                  +260 4515854
                </a>
              </li>
              <li>
                <address className="not-italic">
                  Av. Antartida Argentina 1297  <br />
                  San Rafael , Mendoza, CP 5600.
                </address>
              </li>
            </ul>
          </div>

          {/* Recursos */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Recursos</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="hover:text-white transition-colors">Centro de Ayuda</a>
              </li>
              {/* <li>
                <a href="#" className="hover:text-white transition-colors">Blog</a>
              </li> */}
              {/* <li>
                <a href="#" className="hover:text-white transition-colors">Tutoriales</a>
              </li> */}
              <li>
                <a href="#" className="hover:text-white transition-colors">Preguntas Frecuentes</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright y términos */}
      <div className="border-t border-gray-800 py-6">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
          <div className="text-sm mb-4 md:mb-0">
            &copy; {currentYear} MultiGym. Todos los derechos reservados.
          </div>

          <div className="flex space-x-6">
            <a href="#" className="text-sm hover:text-white transition-colors">
              Términos y Condiciones
            </a>
            <Link to="/privacy" className="text-sm hover:text-white transition-colors">
              Política de Privacidad
            </Link>
            <a href="#" className="text-sm hover:text-white transition-colors">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;